import { render, staticRenderFns } from "./Constructeur.vue?vue&type=template&id=2c05bb43&scoped=true&"
import script from "./Constructeur.vue?vue&type=script&lang=js&"
export * from "./Constructeur.vue?vue&type=script&lang=js&"
import style0 from "./Constructeur.vue?vue&type=style&index=0&id=2c05bb43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05bb43",
  null
  
)

export default component.exports